/**
 * Heatmap multi-sites : intensité de risque (retards + Findings High) par
 * site et par mois.
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CHARTS } from "@/constants/testIds";

const MONTH_LABELS = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function intensityColor(value) {
  if (value >= 70) return "#EF4444";
  if (value >= 40) return "#F59E0B";
  if (value >= 15) return "#FDE68A";
  return "#D1FAE5";
}

export default function MultiSiteHeatmap({ sites = [], months = [], matrix = [] }) {
  return (
    <Card data-testid={CHARTS.heatmap} className="border-slate-200 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-slate-500">Heatmap Multi-Sites</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto pt-0">
        <table className="w-full text-xs">
          <thead>
            <tr>
              <th className="p-1 text-left font-medium text-slate-400">Site</th>
              {months.map((m) => (
                <th key={m} className="p-1 text-center font-medium text-slate-400">
                  {MONTH_LABELS[m - 1]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sites.map((site, i) => (
              <tr key={site}>
                <td className="whitespace-nowrap p-1 pr-3 font-medium text-slate-600">{site}</td>
                {matrix[i]?.map((value, j) => (
                  <td key={j} className="p-0.5">
                    <div
                      data-testid={`heatmap-cell-${i}-${j}`}
                      title={`${site} - ${MONTH_LABELS[j]} : ${value}`}
                      className="h-6 w-6 rounded transition-transform duration-200 hover:scale-110"
                      style={{ backgroundColor: intensityColor(value) }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
